import {fromJS} from 'immutable';
import MAP_STYLE from './default-map-style.json';
// import MAP_STYLE from '../../map-style-basic-v8.json';


export const clustersLayer = fromJS({
        id: "clusters",
        type: "circle",
        source: "clustered-sessions",
        // filter: ["has", "point_count"],
        paint: {

            "circle-color": [
                "step",
                ["get", "point_count"],
                "#ffffff",
                0,"#FF4CB2",
                1,"#FF4CB2",
                2,"#FFDE0A",
                5, "#12E200",
                10,"#FF4CB2"
            ],
            "circle-radius": [
                "step",
                ["get", "point_count"],
                15,
                0,15,
                1, 30,
                2, 40,
                5, 50,
                10,70,
            ],
            "circle-blur": {
                      "base": 0.6,
                      "stops": [
                          [15,1.9],
                      ]
                  },
              "circle-opacity": {
                        "base": 0.8,
                        "stops": [
                            [8,0.9],
                            [12,0.5],
                            [13,0.01],
                            // [7,4],
                            // [9,20],
                            // [9.9,50],
                        ]
                    },
            // "circle-blur" : 1,
            "circle-stroke-color": "#FFDE0A",
            "circle-stroke-width" : {
                      "base": 10,
                      "stops": [
                          // [1,20],
                          [10,20],
                          // [7,4],
                          // [9,20],
                          // [9.9,50],
                      ]
                  },
                  "circle-stroke-opacity" : {
                            "base": 0.7,
                            "stops": [
                                // [1,20],
                                [10,0.5],
                                [13,0.1],
                                // [7,4],
                                // [9,20],
                                // [9.9,50],
                            ]
                        },
            // "circle-stroke-opacity" : 0.5
            // "circle-opacity-transition": {duration: 2000},
        },
        "interactive" : false,
    });


    export const unclusteredLayerOG = fromJS({
        id: "unclustered-point",
        type: "circle",
        source: "clustered-sessions",
        filter: ["!", ["has", "point_count"]],
        paint: {
            "circle-color": "red",
            "circle-radius": 4,
            "circle-stroke-width": 1,
            "circle-stroke-color": "#fff"
        }
    });

    export const unclusteredLayer = fromJS({
        id: "unclustered-point",
        // type: "circle",
        source: "clustered-sessions",
        filter: ["!", ["has", "point_count"]],

        // "id": "points",
        "type": "symbol",
        "layout": {
            "icon-image": "cloud",
            // "icon-size": 0.125,
            "icon-size" : {
                      "base": 0.1,
                      "stops": [
                          // [11,0.03],
                          [10,0.1],
                          [16,0.4],
                          // [7,4],
                          // [9,20],
                          // [9.9,50],
                      ]
                  },
        },
        minzoom: 12,
        interactive: true,
    });

export const animatedLinesLayer = fromJS(        {
        "id": "animated-lines",
        "type": "line",
        "source": "lines",
        "paint": {
            "line-width" : {
                      "base": 4,
                      "stops": [
                          [3,20],
                          [10,6],
                      ]
                  },
            "line-color" : ["get", "color"]
        },
        "minzoom" : 8,
        "interactive" : false
      })
    export const allSessionsLayer = fromJS({
            id: "all-sessions",
            type: "circle",
            source: "sessions",
            paint: {
                "circle-color": "white",
                "circle-radius": 1,
                "circle-opacity": 0.0, // purely for query counf
            },
            "interactive" : false,
            minzoom: 0,
        });

    export const ogCloudLayer = fromJS({
        "id": "cloud",
        "type": "symbol",
        "source": {
            "type": "geojson",
            "data": {
                "type": "FeatureCollection",
                "features": [{
                    "type": "Feature",
                    "geometry": {
                        "type": "Point",
                        "coordinates": [0, 0]
                    }
                }]
            }
        },
        "layout": {
            "icon-image": "cloud",
            "icon-size" : {
                      "base": 0.9,
                      "stops": [
                          [1,0.02],
                          [3,0.1],
                          [4,0.1],
                          [5,0.7],
                          [6,0.8],
                          [7,0.9],
                          // [8,0.9],
                          // [9,1.1],
                      ]
                  },

        },
        interactive: true,
        maxzoom: 7,
    })




export const defaultMapStyle = fromJS(MAP_STYLE);



// WEBPACK FOOTER //
// ./src/components/pages/NightMap/map-style.js